import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import { parseOutcomeData } from '../helpers';
import type { PathCompanyRequestType, PathCompanyResponseType } from '../types';

export const pathCompany = async ({ bodyParams }: PathCompanyRequestType) => {
  const url = `/company/${bodyParams.id}`;
  const company = parseOutcomeData(bodyParams || {});

  const { data } = await apiAuthClient.patch<PathCompanyResponseType>(
    url,
    company,
  );

  return data.data;
};
